export default __webpack_public_path__ + "static/media/win_two.3fc674dc.svg";